<template>
    <div class="help_center">
        <Card class="my_card">
            <div class="title">请选择子商户登录</div>
            <div class="choose_area" v-for="(item, index) in list" :key="index">
                <Button type="primary" shape="circle" ghost :data-token="item.token" @click="chooseItem">{{item.name}}</Button>
            </div>
            <div class="no_result" v-if="list.length == 0">
                该账号下暂无子商户
            </div>
        </Card>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {getMyShop} from '@/api/admin'

    export default {
        name: "adminSet",
        components: {
        },
        computed:{
            ...mapGetters(['userInfo', 'token']),
        },
        data() {
            return {
                list: []
            }
        },
        created(){
            this.loadData();
        },
        methods: {
            ...mapActions([
                'handleToken',
                'getUserInfo'
            ]),
            async loadData() {
                let that = this;
                let data = {token: that.token, set:that.set}
                let res = await getMyShop(that, data);
                if (res.code == 1) {
                    that.list = res.data.list;
                }
            },
            chooseItem(e) {
                let that = this;
                let token = e.currentTarget.dataset.token;
                that.$Modal.confirm({
                    title: '确认选择该账号登录吗？',
                    onOk: async() => {
                        that.handleToken(token);
                        this.getUserInfo().then(res => {
                            if (res.code == 1) {
                                this.$router.push({
                                    name: res.data.router
                                })
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped lang="less">
    .help_center {
        background: #f5f7f9;
        .my_card{
            margin: 0 35%;
            padding: 20px;
            margin-top: 5%;
            .title{
                text-align: center;
                font-size: 16px;
                font-width: bold;
            }
        }
        .no_result{
            margin-top: 50px;
            font-size: 20px;
            color: grey;
            text-align: center;
        }
        .choose_area{
            text-align: center;
            margin-top: 10px;
        }
    }

    .yl-flex {
        display: flex;
        justify-content: space-between;
    }
    .ivu-form-item{
        display: inline-block;
        width: 300px;
        margin-left: 15px;
    }

</style>
